"use strict";
module.exports = {
    entityModel: 'cart',
    events: {
        CART_CREATED: 'CART_CREATED',
        CART_SENT_TO_EXTERNAL_MARKETPLACE: 'CART_SENT_TO_EXTERNAL_MARKETPLACE',
        CART_READY_IN_EXTERNAL_MARKETPLACE: 'CART_READY_IN_EXTERNAL_MARKETPLACE',
        CART_PLACED_TO_ORDER: 'CART_PLACED_TO_ORDER',
        CART_ABANDONED: 'CART_ABANDONED',
        CART_UPDATED: 'CART_UPDATED',
        CART_DEACTIVATED: 'CART_DEACTIVATED',
    },
    actions: {
        get: 'v1.cart.get',
        list: 'v1.cart.list',
        writeAndPlaceOrder: 'v1.cart.writeAndPlaceOrder',
        sendCartToExternalMarketplace: 'v1.cart.sendCartToExternalMarketplace',
        setCartReadyInExternalMarketplace: 'v1.cart.setCartReadyInExternalMarketplace',
        placeToOrder: 'v1.cart.placeToOrder',
        abandonCart: 'v1.cart.abandonCart',
        copyExistingOrderToCart: 'v1.cart.copyExistingOrderToCart',
        setCartRow: 'v1.cart.setCartRow',
        setCartRowFromArticleNumber: 'v1.cart.setCartRowFromArticleNumber',
        deactivate: 'v1.cart.deactivate',
        upsert: 'v1.cart.upsert',
        upsertWhenEmpty: 'v1.cart.upsertWhenEmpty',
        updateWhenEmpty: 'v1.cart.updateWhenEmpty',
        update: 'v1.cart.update',
    },
    cartStates: {
        building: 'building',
        sentToExternalSystem: 'sentToExternalSystem',
        readyForPurchaseInExternalSystem: 'readyForPurchaseInExternalSystem',
        placedToOrder: 'placedToOrder',
        abandoned: 'abandoned',
    },
    cartTypes: {
        standard: 'standard',
        external: 'external',
    },
    cartRows: {},
};
